<template>
	<div>
		<div :class="desktopClass">
			<div v-for="(item, index) in itemsList" :key="item.id || index" :class="desktopListClass">
				<slot :item="item" />
			</div>
		</div>

		<div :class="mobileClass">
			<vueper-slides
				ref="vueperslides_graduate-tips"
				:fixed-height="true"
				:touchable="true"
				:autoplay="false"
				:bullets="true"
				bullets-outside
				:loop="true"
				:arrows="false"
				:gap="2"
				:infinite="false"
				:dragging-distance="50"
				transition-speed="250"
				prevent-y-scroll
				fade
				class="no-shadow graduate-tips-slider col-12"
			>
				<vueper-slide
					v-for="(item, index) in itemsList"
					:key="item.id || index"
				>
					<template #content>
						<slot :item="item" />
					</template>
				</vueper-slide>
			</vueper-slides>
		</div>
	</div>
</template>

<script>
import { VueperSlide, VueperSlides } from 'vueperslides';

export default {
	name: 'ListWithMobileSlider',
	components: { VueperSlides, VueperSlide },
	props: {
		desktopClass: {
			type: String,
			default: 'd-none d-lg-flex',
		},
		desktopListClass: {
			type: String,
			default: '',
		},
		mobileClass: {
			type: String,
			default: 'd-flex d-lg-none',
		},
		itemsList: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.vueperslides--fixed-height {
	height: 100%;
	aspect-ratio: 16/9;
}

.vueperslides__inner {
	background-color: $theme-dark;
}

.vueperslides--fade .vueperslide {
	transition-duration: .7s;
}

.graduate-tips-button-group {
	width: 120px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.button-wrapper {
		cursor: pointer;
		width: 50px;
		height: 50px;
		padding: 0.6rem;
		border-radius: 50%;
		background-color: #c4c8de;
		display: flex;
		align-items: center;
		justify-content: center;
		svg {
			width: 1.5rem;
			height: auto;
			path {
				fill: white !important;
			}
		}

		&:hover {
			background-color: $blue;
		}
	}
}
.button-wrapper {
	svg {
		width: 1.5rem;
		height: auto;
		path {
			fill: white !important;
		}
	}
}
</style>

<style lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.graduate-tips-slider {
	.vueperslides__bullets {
		position: absolute;
		height: 1rem;
		bottom: -1.2rem;
		z-index: 1;
	}

	.vueperslides__bullet {
		margin: 1rem 0.3rem;
	}

	.vueperslides__bullet .default {
		background-color: $blue;
		border: none;
		width: 0.4rem;
		height: 0.4rem;
		box-shadow: none;
	}

	.vueperslides__bullet--active .default {
		background-color: $blue;
		width: 0.87rem;
		height: 0.87rem;
		border: none;
	}
}
</style>
